import axios from '../..';

export const fetchBasicInfo = () => axios.get('api/admin/org/basicInfo');

export const updateBasicInfo = data =>
  axios.patch('api/admin/org/updateBasicInfo', data);

export const deleteOrganisationLogo = () =>
  axios.patch(`api/admin/org/deleteOrgLogo`);
